import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RestaurantProfile } from 'src/app/features/restaurants/models/List.Restaurant';
import { RestaurantService } from 'src/app/features/restaurants/services/Restaurant.service';
import { DirtyComponent } from 'src/app/helpers/CanDeactivate/dirty-component';
import { CustomValidator } from 'src/app/helpers/custom.validator';
import Swal from 'sweetalert2';

export interface DialogData {
  restaurantProfile: RestaurantProfile,
}

@Component({
  selector: 'app-zatca-form',
  templateUrl: './zatca-form.component.html'
})
export class ZatcaFormComponent extends DirtyComponent implements OnInit {
  loading = false;

  constructor(
    override dialogRef: MatDialogRef<ZatcaFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    translate: TranslateService,
    private service: RestaurantService,
    public router: Router
  ) { super(translate) }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      restaurantId: [this.data.restaurantProfile.id],
      registerationType: [null, Validators.required],
      sellerName: [null, [
        Validators.required, CustomValidator.noWhiteSpace]
      ],
      otp: [null, [
        Validators.required, CustomValidator.noWhiteSpace]],
      isProduction: [false],
      mode: [null, Validators.required],
    });
  }
  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  saveRecord() {
    if (this.formGroup.valid) {
      this.loading = true;
      let data = this.formGroup.value;

      this.service.ResZatcaAuthorityRegistration(data).subscribe((response: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        Swal.fire({
          title: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          showCancelButton: false,
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        })
      }, error => {
        this.loading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Failed'),
          text: error.detail,
          icon: 'error',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
      });
    }
  }

}
